<template>
  <div>
    <div>
      <h2 class="mb-5">
        What is your ethnic group?
      </h2>
    </div>
    <div v-if="isFetchingData">
      <v-skeleton-loader type="list-item-three-line" />
    </div>
    <div v-else>
      <v-radio-group class="radio" v-model="ethnicGroupId">
        <div
          v-for="(categoryItems, category) in formattedEthnicGroups"
          :key="category"
        >
          <h3 class="font-weight-bold mb-2 mt-1">
            {{ category | capitalize }}
          </h3>
          <div
            class="radio--standard"
            @click="ethnicGroupId = option.value"
            :class="{
              'radio--standard__active':
                Number(ethnicGroupId) === Number(option.value)
            }"
            v-for="(option, index) in categoryItems"
            :key="`opt-${index}`"
          >
            <v-radio
              :label="option.label"
              :value="option.value"
              :ripple="false"
              color="white"
            />
          </div>
        </div>
      </v-radio-group>
    </div>
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import {
  GET_ETHNIC_GROUPS,
  GET_IS_FETCHING_DATA
} from "@/store/modules/data/getters";
import { FETCH_ETHNIC_GROUPS } from "@/store/modules/data/actions";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { get, toString } from "lodash";

const { mapGetters, mapActions } = createNamespacedHelpers(DATA_NAMESPACE);

export default {
  name: "Ethnicity",
  components: {
    PrimaryButton
  },
  props: {
    isLoading: Boolean,
    userData: Object
  },
  created() {
    this.fetchEthnicGroups();
  },
  data() {
    return {
      ethnicGroupId: this.userData.ethnicOrigin && this.userData.ethnicOrigin.id
    };
  },
  computed: {
    ...mapGetters({
      ethnicGroups: GET_ETHNIC_GROUPS,
      isFetchingData: GET_IS_FETCHING_DATA
    }),
    initialSelected() {
      return toString(get(this.userData, "ethnicOrigin.id"));
    },
    formattedEthnicGroups() {
      return this.ethnicGroups.reduce(
        (
          formattedEthnicGroups,
          { category: { name: categoryName }, name, id }
        ) => {
          const functionItem = {
            label: name,
            value: id
          };
          if (formattedEthnicGroups[categoryName]) {
            formattedEthnicGroups[categoryName].push(functionItem);
          } else {
            formattedEthnicGroups[categoryName] = [functionItem];
          }
          return formattedEthnicGroups;
        },
        {}
      );
    }
  },
  methods: {
    ...mapActions({
      fetchEthnicGroups: FETCH_ETHNIC_GROUPS
    }),
    nextStep() {
      this.$emit("nextStep", {
        data: this.ethnicGroupId && { ethnicGroupId: this.ethnicGroupId },
        dataType: "mainDetails"
      });
    }
  }
};
</script>

<style lang="scss"></style>
